import { Component, Input } from '@angular/core';
import { NgxCurrencyConfig, NgxCurrencyInputMode } from 'ngx-currency';
import { CustomCurrencyMaskConfig } from 'src/app/shared/config/currency-mask.config';
import { DistributionAmountInputFormGroup } from '../../../../distribution-request/models/distribution-form.model';
import { CloseAccountFormGroup } from '../../../../close-account-request/models/close-account-form.model';

@Component({
  selector: 'app-tax-options',
  templateUrl: './tax-options.component.html'
})
export class TaxOptionsComponent {
  @Input() taxFormGroup?: DistributionAmountInputFormGroup | CloseAccountFormGroup;
  @Input() fedTaxClone: number | undefined;
  @Input() stateTaxClone: number | undefined;

  stateTaxMaskOptions: NgxCurrencyConfig = {
    ...CustomCurrencyMaskConfig, ...{
      precision: 2,
      allowNegative: false,
      prefix: '',
      suffix: '%',
      max: 100.00,
      inputMode: NgxCurrencyInputMode.Natural,
    }
  };
  federalTaxMaskOptions: NgxCurrencyConfig = {
    ...CustomCurrencyMaskConfig, ...{
      precision: 2,
      allowNegative: false,
      prefix: '',
      suffix: '%',
      max: 100.00,
      inputMode: NgxCurrencyInputMode.Natural,
    }
  };
}
